import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";

export const PromptDisplay = ({
  content,
  className,
  showCopyButton = true,
  placeholder,
}) => {
  // Function to parse and highlight variables in the format { variable name }
  const parsePromptWithVariables = (text) => {
    if (!text || typeof text !== 'string') {
      return text;
    }

    const variableRegex = /\{\s*([^}]+)\s*\}/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = variableRegex.exec(text)) !== null) {
      // Add text before the variable
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }

      // Add the highlighted variable
      parts.push(
        <span
          key={`var-${match.index}`}
          className="bg-light-5 text-red px-1 py-0.5 rounded text-sm font-medium"
        >
          {match[0]}
        </span>
      );

      lastIndex = match.index + match[0].length;
    }

    // Add remaining text after the last variable
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts.length > 0 ? parts : text;
  };

  const hasValidPrompt = Boolean(
    content &&
    typeof content === 'string' &&
    content.trim().length > 0
  );

  const handleCopy = () => {
    if (hasValidPrompt) {
      navigator.clipboard.writeText(content);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <div
        className="w-full p-6 font-mono bg-white text-black border border-gray-600 rounded-xl shadow-inner whitespace-pre-wrap"
        style={{ minHeight: 250 }}
      >
        {hasValidPrompt ? (
          parsePromptWithVariables(content)
        ) : (
          <span className="text-black">{placeholder}</span>
        )}
      </div>

      {/* Copy button in top right */}
      {hasValidPrompt && showCopyButton && (
        <button
          onClick={handleCopy}
          title="Copy to Clipboard"
          className="absolute text-sm uppercase top-3 right-3 py-1.5 px-3 bg-dark-10 hover:bg-dark-20 text-link hover:text-black rounded-lg transition-colors focus:outline-none focus:ring-0"
        >
          <FontAwesomeIcon icon={faClipboard} /> Copy
        </button>
      )}
    </div>
  );
};
